<template>
    <el-popover
        :width="!width ? confirmable ? 300 : 150 : width"
        v-bind="$attrs"
        v-on="$listeners"
        :value="value"
        :popper-class="allPopperClass"
    >
        <template slot="reference">
            <slot name="reference">
                <div class="flexible-popover-wrapper" v-if="movable">.</div>
            </slot>
        </template>

        <template slot="default">
            <div class="el-popover__title" v-if="title" v-text="title" :style="[confirmable && {marginBottom: '20px'}]"></div>
            <slot>{{ content }}</slot>
            <slot name="btn">
                <el-row type="flex" justify="end"  class="dap-popover-btn" v-if="confirmable">
                    <el-button size="mini" @click="handleCancel">{{ cancelText }}</el-button>
                    <el-button size="mini" type="primary" :loading="confirmBtnLoading" @click="handleConfirm">
                        {{ confirmText }}
                    </el-button>
                </el-row>
            </slot>
        </template>

    </el-popover>
</template>
<script>
export default {
    name: 'DapPopover',
    inheritAttrs: false,
    props: {
        popperClass: {
            type: String,
            default: '',
        },
        confirmable: {
            type: Boolean,
            default: false,
        },
        confirmBtnLoading: {
            type: Boolean,
            default: false,
        },
        cancelText: {
            type: String,
            default: '取消',
        },
        confirmText: {
            type: String,
            default: '保存',
        },
        width: {
            type: [String, Number],
            default: 0,
        },
        movable: {
            type: Boolean,
            default: false,
        },
        triggerClass: {
            type: String,
            default: '',
        },
        changeRequirement: {
            type: Object,
            default: () => ({}),
        },
        value: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        content: {
            type: String,
            default: '',
        },
    },
    data () {
        return {
            clientX: 0,
            clientY: 0,
            scrollX: 0,
            scrollY: 0,
            target: null,
        };
    },
    computed: {
        allPopperClass () {
            return `${this.popperClass || ''} dap-popover`;
        },
    },
    mounted() {
        if (this.movable && !this.confirmable) {
            document.addEventListener('click', this.handleDocumentClick);
            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('click', this.handleDocumentClick);
            });
        }
    },
    methods: {
        handleCancel () {
            this.$emit('cancel');
        },

        handleConfirm () {
            this.$emit('confirm');
        },

        equalNode (node, nodeList) {
            for (let i in nodeList) {
                if (nodeList.item(i) === node) {
                    return true;
                }
            }
            return false;
        },

        containNode (node, nodeList) {
            for (let i in nodeList) {
                if (nodeList.item(i) && nodeList.item(i).contains(node)) {
                    return true;
                }
            }
            return false;
        },

        handleDocumentClick (e) {
            const popper = document.getElementsByClassName(this.popperClass);
            const elements = document.getElementsByClassName(this.triggerClass);
            if (!popper || this.containNode(e.target, popper) || !elements || this.containNode(e.target, elements)) return;
            this.$emit('close');
        },

        handleClick (e) {
            const elements = document.getElementsByClassName(this.triggerClass);
            let target = e.target;
            while (!this.equalNode(target, elements) && !target.clientWidth) {
                target = target.parentNode;
            }
            this.clientX = e.clientX - e.offsetX + target.clientWidth / 2 - 5;
            this.clientY = e.clientY - e.offsetY + target.clientHeight / 2 - 5;
            this.target = target;
            [this.scrollX, this.scrollY] = this.calcScroll(target);
            this.$nextTick(() => {
                if (this.value) {
                    this.addScrollListener(target);
                    const popoverNode = document.getElementsByClassName(this.popperClass);
                    // 如果一个页面打开多个 生成了多个popperClass对象,需要遍历
                    for (let node of popoverNode) {
                        if (node) {
                            node.style.transform = `translate(${this.clientX - 400}px, ${this.clientY - 400}px)`;
                        }
                    }
                }
            });
        },

        handleScroll () {
            if (this.confirmable) {
                const [scrollX, scrollY] = this.calcScroll();
                const popoverNode = document.getElementsByClassName(this.popperClass)[0];
                popoverNode.style.transform = `translate(${this.clientX - 400 + this.scrollX - scrollX}px, ${this.clientY - 400 + this.scrollY - scrollY}px)`;
            } else {
                this.$emit('update:value', false);
            }
        },

        calcScroll() {
            let current = this.target;
            let scrollX = 0, scrollY = 0;
            while (!current.contains(document.body)) {
                current = current.parentNode
                scrollX += current.scrollLeft;
                scrollY += current.scrollTop;
            }
            return [scrollX, scrollY]
        },

        addScrollListener () {
            let current = this.target;
            while (!current.contains(document.body)) {
                current = current.parentNode;
                current.addEventListener('scroll', this.handleScroll)
                this.$once('hook:beforeDestroy', () => {
                    current.removeEventListener('scroll', this.handleScroll);
                });
            }
        },

        addListener () {
            const elements = document.getElementsByClassName(this.triggerClass);
            for (let el of elements) {
                el.addEventListener('click', this.handleClick);
            }
            this.$once('hook:beforeDestroy', () => {
                this.removeListener(elements);
            });
        },

        removeListener (elements) {
            const targets = elements || document.getElementsByClassName(this.triggerClass);
            for (let el of targets) {
                el.removeEventListener('click', this.handleClick);
            }
        }
    },

    watch: {
        changeRequirement: {
            handler (val) {
                if (this.movable) {
                    this.$nextTick(() => {
                        this.removeListener();
                        this.addListener();
                    });
                }
            },
            deep: true,
            immediate: true,
        },
    }
}
</script>

<style lang="scss">
.dap-popover.el-popover {
    padding: 10px;
    font-size: 12px;
    color: #606266;
    line-height: 18px;

    .el-popover__title {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #333333;
        margin-bottom: 10px;
    }

    .dap-popover-btn {
        margin-top: 20px;
    }
}

.flexible-popover-wrapper {
    position: fixed;
    top: 400px;
    left: 400px;
    z-index: 800;
    opacity: 0;
    height: 10px;
    width: 10px;
}

</style>
